// @ts-nocheck
import React from "react";

const Diagram: React.FC = () => {
    return (
        <svg height="18" width="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500.143 500.143">
            <g>
                <path
                    fill="currentColor"
                    d="M494.705,109.571l-161.287-56.9c-0.244-0.089-0.496-0.106-0.74-0.171
		c-0.341-0.089-0.667-0.187-1.008-0.228c-0.325-0.041-0.642-0.016-0.959-0.016c-0.317,0-0.634-0.016-0.959,0.016
		c-0.341,0.041-0.675,0.146-1.008,0.228c-0.244,0.065-0.504,0.081-0.74,0.171L169.416,108.62L10.827,52.671
		c-2.487-0.886-5.243-0.496-7.397,1.024S0,57.695,0,60.328v322.583c0,3.447,2.178,6.519,5.422,7.665l161.295,56.9
		c0.041,0.016,0.089,0.008,0.138,0.024c0.829,0.276,1.691,0.439,2.569,0.439s1.74-0.163,2.569-0.439
		c0.041-0.016,0.089-0.008,0.138-0.024l158.597-55.949l158.58,55.949c0.878,0.309,1.796,0.463,2.707,0.463
		c1.658,0,3.3-0.512,4.69-1.496c2.162-1.528,3.438-3.999,3.438-6.633V117.237C500.127,113.79,497.948,110.717,494.705,109.571z
		 M16.249,71.822l145.038,51.161v305.35L16.249,377.164C16.249,377.164,16.249,71.822,16.249,71.822z M177.544,122.983
		l145.038-51.161v305.342l-145.038,51.169V122.983z M483.87,428.333l-145.03-51.169V71.822l145.03,51.161V428.333z"
                />
            </g>
        </svg>
    );
};

export default React.memo(Diagram);
